import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { toISODate } from '../../../../helpers/dateTime';

import { useVoucherFormContext } from '../../Context';

import { TravelPeriodRule } from '../../../../types/Rules';

const SinceDate = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const ruleValue = rules.filter(r => r.type === 'travel_period')[0] as
    | TravelPeriodRule
    | undefined;

  const dateObject = ruleValue?.start ? DateTime.fromISO(ruleValue.start) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='rule-valid-since-input'
        id='rule-valid-since-input'
        label={<>Travel departure since</>}
        type='date'
        min={new Date().toString()}
        info={`The travel validity starts at 00:00 GMT${DateTime.local().toFormat('ZZ')}`}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            // Remove the rule
            handleRuleChange(
              {
                type: 'travel_period',
                ...ruleValue,
                start: '',
              },
              true,
            );
          } else {
            const date = new Date(value);
            handleRuleChange({
              type: 'travel_period',
              ...ruleValue,
              start: toISODate(DateTime.fromJSDate(date)),
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default SinceDate;
